const USER_PERMISSION_TYPE = {
  Country: 'COUNTRY',
  Schedule: 'SCHEDULE',
  ServiceType: 'SERVICE_TYPE',
  Weekday: 'WEEKDAY'
};

export { USER_PERMISSION_TYPE };
